export default __webpack_public_path__ + "media/images/logos/logo_light-63d404606862591dc6e86b46a240969e.png";